/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable complexity */
// Extended by FormComponent
import _ from 'lodash';
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import FormComponent from '../FormComponent';
import InputField from '../InputField';
import RadioComponent from '../RadioComponent';
import SchoolFinder from '../SchoolFinder';
import TournamentFinder from '../TournamentFinder';
import TournamentEventDetails from '../TournamentEventDetails';
import TournamentEventForm from '../TournamentEventForm';
import CoachFinder from '../CoachFinder';
import SchoolInputCode from '../SchoolInputCode';
import SearchInputField from '../SearchInputField';
import SelectComponent from '../SelectComponent';
import ParkFinder from '../parkFinder';
import VenueAddressSearch from '../VenueAddressSearch';
import DateComponent from '../DateComponent';
import DuetDateComponent from '../DuetDateComponent';
import CheckboxComponent from '../CheckboxComponent';
import FileUploadComponent from '../FileUploadComponent';
import PlayerList from '../PlayerList';
import ContactNumber from '../ContactNumber';
import KeyPoints from '../KeyPoints';
import BackButton from '../BackButton';
import ExitButton from '../ExitButton';
import Stepper from '../Stepper';
import { Events } from '../../utils/dom/html-events';
import { ClassNames } from '../../utils/dom/css-classes';
import MentorFinder from '../MentorFinder';
import FormTable from '../Table';
import {
	extraCoachData,
	extraSchoolData,
	extraCountyData,
	extraCoachVenueSearchData,
	extraParkData,
	extraTournamentData,
	extraMentorData,
	extraAuthorityData,
	extraUniversityData,
	extraAddressData
} from './data';
import AffiliatedVenueSearchList from '../AffiliatedVenueSearchList';
import AuthorityFinder from '../AuthorityFinder';
import SessionPlayersList from '../SessionPlayersList';
import AddressFinder from '../AddressFinder';
import CheckoutComponent from '../CheckoutComponent';

export const QuestionTypes = {
	Radio: 'radio',
	SchoolSearch: 'schoolSearch',
	UniversitySearch: 'universitySearch',
	TournamentSearch: 'tournamentSearch',
	TournamentEventDetails: 'tournamentEventDetails',
	TournamentEventForm: 'tournamentEventForm',
	ITTProviderSearch: 'ittProviderSearch',
	CountySearch: 'countySearch',
	ParkFinder: 'parkFinder',
	CoachVenueSearch: 'coachVenueSearch',
	VenueAddressSearch: 'venueAddressSearch',
	Select: 'select',
	CoachSearch: 'coachSearch',
	SchoolSortCode: 'schoolSortCode',
	DateComponent: 'dateComponent',
	Checkbox: 'checkbox',
	FileUpload: 'fileUpload',
	Info: 'info',
	MentorFinder: 'mentorFinder',
	DuetDateComponent: 'duetDateComponent',
	FormTable: 'formTable',
	AffiliatedVenueSearchList: 'affiliateVenueSearchList',
	TextArea: 'textArea',
	AuthorityFinder: 'auhorityFinder',
	PlayerList: 'playerList',
	ContactNumber: 'contactNumber',
	SessionPlayerList: 'sessionPlayerList',
	TextInput: 'textInput',
	AddressFinder: 'addressFinder',
	Checkout: 'checkout'
};

export const FormTypes = {
	StepForm: 'stepForm',
	SectionForm: 'sectionForm'
};

const HIDE_CLASS = 'u-hidden';
export default class FormGenerator extends FormComponent {
	get questions() {
		return this._questions;
	}

	set questions(_questions) {
		this._questions = _questions.filter((question) => !!question?.id);
	}

	get answers() {
		return this._answers;
	}

	set answers(_answers) {
		// eslint-disable-next-line no-console
		console.log({ _answers });
		this._answers = _answers;
	}

	get currentStep() {
		return this._currentStep;
	}

	set currentStep(_step) {
		this._currentStep = _step;
		if(this.data) {		
			if (!this.isSectionForm) {
				this.updateStep();
			}
			this.updateStepButtonLabel();
		}
	}

	constructor(containerElement, config) {
		super(containerElement, config);
		this.currentStep = 1;
		this._stepChangeCallbacks = [];
		this._submitHandler = [];
		this.classPrefix = 'lta-form-generator';
		this.answers = {};
		this.totalSteps = config.totalSteps || 3;
		this.stepVisibility =
			config?.stepVisibility?.length > 0 ? config?.stepVisibility : this.stepVisibilityEnable(this.totalSteps);
		this.hasQuestionSteps = [...this.stepVisibility];
		this.questions = _.cloneDeep(config.questions);
		this.data = config;
		this.formType = config?.formType;
		this.isRenderDependentQuestion = true;
		this.conditionalStepsVisiblity = !!config?.conditionalStepsVisiblity;
	}
	stepVisibilityEnable(totalSteps) {
		const stepsVisibilityArray = [];
		for (let index = 0; index < totalSteps; index++) {
			stepsVisibilityArray.push(true);
		}
		return stepsVisibilityArray;
	}
	onStepChange(callback) {
		this._stepChangeCallbacks.push(callback);
	}
	onSubmit(callback) {
		this._submitHandler.push(callback);
	}
	afterStepChange(step) {
		for (const callback of this._stepChangeCallbacks) {
			callback(step);
		}
	}
	submitForm() {
		for (const callback of this._submitHandler) {
			callback(this.answers, this.value);
		}
	}
	markup() {
		const themeColor = this.data?.themeColor;
		if (this.data.isBackButtonEnabled) {
			this.backButton = new BackButton(this.containerEl, { classPrefix: this.classPrefix });
		}
		if (this.data.isExitButtonEnabled) {
			this.exitButton = new ExitButton(this.containerEl, { classPrefix: this.classPrefix });
		}

		if (!this.data?.isHideProgress) {
			this.stepper = new Stepper(this.containerEl, {
				classPrefix: this.classPrefix,
				stepTitle: this.getStepTitle(),
				totalSteps: this.totalSteps,
				currentStep: this.currentStep,
				stepVisibility: this.stepVisibility,
				themeColor
			});
		}

		const buttonTitle = 'Next';
		this.isSectionForm = this.data?.formType === FormTypes.SectionForm;
		this.isSeparator = !!this.data?.isSeparator;
		this.mainPageElement = this.data?.mainPageElement;
		this.setBackgroundColor();

		return `
			<div class="${this.classPrefix}__form-action-button-container">
				<div class="${this.classPrefix}__form-action-button-inner">
					<div>
						${this.backButton?.markup() || ''}
					</div>
					<div>
						${this.exitButton?.markup() || ''}
					</div>
				</div>
			</div>
            <div class="${this.classPrefix}__form-wrapper" style="--lta-theme--1: var(--${themeColor})">
				${this.stepper?.markup() || ''}
				<div class="${this.classPrefix}__form-container">${this.renderFormContainer()}</div>
				<div class="${this.classPrefix}__form-next ${this.isSectionForm && !this.data?.submitButton?.alwaysVisible ? ClassNames.Hidden : ''}">
                    <button type="button" class="lta-btn lta-btn--default lta-btn--primary lta-btn--block js-form-generator-next-button ${this.classPrefix}__form-next-button" data-target="${this.data?.submitButton?.dataTarget}">${buttonTitle}</button>
                </div>
            </div>
        `;
	}

	afterRender() {
		this.nextButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-next-button`, this.containerEl);
		this.backButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this.containerEl);
		this.exitButtonEl = SelectorEngine.findOne(`.${this.classPrefix}__form-exit-button`, this.containerEl);
		this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
		this.renderQuestions();
		this.setUpForwardAndBackEvents();
		// Get button reference.
	}

	reRenderForm(updatedStepData) {
		if (this.nextButtonEl) {
			this.nextButtonEl.disabled = false;
		}
		this.currentStep = updatedStepData?.[0]?.step;
		const question = this.questions?.find((question) => question?.id === updatedStepData?.[0]?.id);
		question?.ref?.reRenderQuestion(updatedStepData?.[0]?.supportingProps);
		this.nextButtonToggle();
	}

	setUpForwardAndBackEvents() {
		if (this.nextButtonEl) {
			EventHandler.on(this.nextButtonEl, Events.Click, (event) => {
				this.nextButtonClickHandler(event);
			});
		}

		if (this.backButtonEl) {
			EventHandler.on(this.backButtonEl, Events.Click, () => {
				if(this.currentStep === 1) {
					if(this.data?.backButtonHandlerFirstStep) {
						this.data?.backButtonHandlerFirstStep();
						this.unload();
					} else {
						window?.history?.back();
					}
				} else {
					this.backButtonClickHandler();
				}
			});
		}

		if (this.exitButtonEl) {
			EventHandler.on(this.exitButtonEl, Events.Click, () => {
				this.data?.exitButtonHandler?.();
			});
		}
	}

	nextButtonClickHandler(event) {
		const valid = this.stepValidator(this.currentStep);
		if (this.currentStep < this.totalSteps && valid) {
			this.currentStep = this.currentStep + 1;
			this.checkQuestionNextClick(this.currentStep - 1);
			this.afterStepChange(this.currentStep);
			this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
			this.performActionOnNextStep();
			this.setBackgroundColor();
		} else if (this.currentStep === this.totalSteps && valid) {
			event.target.disabled = true;
			this.value = this.answers;
			this.submitForm();
		}
	}

	enableSubmitButton() {
		const submitButton = SelectorEngine.findOne('.js-form-generator-next-button', this.containerEl);
		if (submitButton && this.currentStep === this.totalSteps) {
			submitButton.disabled = false;
		}
	}

	performActionOnNextStep() {
		const stepQuestion = this.questions.find((question) => question.step === this.currentStep);
		if (stepQuestion?.ref?.data?.hasPerformActionOnload) {
			stepQuestion?.ref?.performActionOnLoad();
		}
	}

	checkQuestionNextClick(steps) {
		for (let index = steps; index < this.totalSteps; index++) {
			if (!this.hasQuestionSteps[index]) {
				this.currentStep = this.currentStep + 1;
			} else {
				return this.currentStep;
			}
		}
		return 0;
	}

	checkQuestionBackClick(steps) {
		for (let index = steps; index > 1; index--) {
			if (!this.hasQuestionSteps[index]) {
				this.currentStep = this.currentStep - 1;
			} else {
				return this.currentStep;
			}
		}
		return 0;
	}

	backButtonClickHandler() {
		this.currentStep = this.currentStep - 1;
		this.checkQuestionBackClick(this.currentStep - 1);
		this.afterStepChange(this.currentStep);
		this.hideShowStepper(this.stepVisibility[this.currentStep - 1]);
		this.setBackgroundColor();
		// if (this.currentStep === 1) {
		// 	this.backButton.hide();
		// }
	}

	hideShowStepper(value) {
		if (!this.conditionalStepsVisiblity) {
			return;
		}
		const stepperElement = SelectorEngine.findOne(`.lta-steps`, this.containerEl);
		if (value) {
			stepperElement?.classList.remove(HIDE_CLASS);
		} else {
			stepperElement?.classList.add(HIDE_CLASS);
		}

		if (stepperElement) {
			for (let index = 0; index < this.totalSteps; index++) {
				const hideStepperElement = SelectorEngine.findOne(`.lta-steps__item-${index + 1}`, this.containerEl);
				if (this.stepVisibility[index] && !this.hasQuestionSteps[index]) {
					hideStepperElement.classList.add('lta-steps_visibility-hidden');
				}
			}
		}
	}

	setBackgroundColor() {
		if (this.mainPageElement) {
			const stepQuestion = this.questions.find((question) => question.step === this.currentStep);
			const backgroundColorClassData = stepQuestion?.backgroundColorClass
				? stepQuestion?.backgroundColorClass
				: 'u-bg-white';
			for (let i = 0; i < this.mainPageElement.classList.length; i++) {
				if (this.mainPageElement.classList[i].includes('u-bg')) {
					this.mainPageElement.classList.remove(this.mainPageElement.classList[i]);
				}
			}
			this.mainPageElement.classList.add(backgroundColorClassData);
		}
	}

	formValidation() {
		let isValid = true;
		Array.from({ length: this.totalSteps }, (__, index) => {
			const isCurrentValid = this.stepValidator(index + 1);
			if (!isCurrentValid) {
				isValid = false;
			}
			return isValid;
		});
		if (isValid) {
			this.value = this.answers;
		}
		return isValid;
	}

	renderFormContainer() {
		return Array.from({ length: this.totalSteps })
			.map(
				(__, index) => `
            <div class="${this.classPrefix}__step js-form-generator-step-${index + 1} ${
					!this.isSectionForm && index > 0 ? ClassNames.Hidden : ''
				} ${this.data?.wrapperClasses?.[index] || ''}">
                ${
									this.isSeparator && index !== 0 && index < this.totalSteps
										? `<div class="sectionSeparator u-mb-5"></div>`
										: ``
								}
                ${
									this.isSectionForm
										? `<div class="lta-form-generator__section-title u-mb-2 md:u-mb-3">${this.renderSectionTitle(
												index + 1
										  )}</div>`
										: ''
								}
                ${this.renderQuestionContainers(index + 1)}
            </div>
        `
			)
			.join('');
	}

	renderSectionTitle(step) {
		const questionTitleArray = this.questions
			?.filter((question) => !!question)
			?.filter((question) => question.step === step)
			.map((question) => question?.stepTitle);
		const titleArray = [...new Set(questionTitleArray)];
		return titleArray[0] || '';
	}

	renderQuestionContainers(step) {
		return this.questions
			?.filter((question) => !!question)
			?.filter((question) => question.step === step)
			.map(
				(question, index) => `
                    <div class="${this.classPrefix}__question-container js-form-generator-question-${question.id} ${
					this.data?.hasSeparator && index > 0 ? `${this.classPrefix}-has-separator` : ''
				}  lta-heading"></div>
                `
			)
			.join('');
	}

	renderQuestions() {
		for (const question of this.questions) {
			if (question?.visible) {
				this.renderQuestion(question);
			} else {
				// Remove question instance and reference.
				this.removeQuestion(question);
			}
		}
	}

	removeDependentQuestions(previousDependentQuestion) {
		if (
			previousDependentQuestion?.questionType === QuestionTypes.Radio ||
			previousDependentQuestion?.questionType === QuestionTypes.Checkbox
		) {
			for (let index = 0; index < previousDependentQuestion?.options?.length; index++) {
				this.setVisibilityHide(previousDependentQuestion?.options[index]?.dependentQuestion);
			}
		} else {
			this.setVisibilityHide(previousDependentQuestion?.dependentQuestion);
		}
	}

	setVisibilityHide(dependentQuestions = []) {
		for (let index = 0; index < dependentQuestions?.length; index++) {
			const dependentQuestion = this.questions.find((question) => question.id === dependentQuestions[index]);
			if (dependentQuestion) {
				this.removeDependentQuestions(dependentQuestion)
				dependentQuestion.visible = false;
				this.updateAnswers(dependentQuestion, "");
			}
		}
	}

	beforeDepChangeHandler(newDeps, previousDeps) {
		// Hide previous dependent Question
		previousDeps?.forEach((id) => {
			const previousDependentQuestion = this.questions.find((question) => question.id === id);
			const previousDependentAnswer = this.answers[this.currentStep];
			if (previousDependentQuestion) {
				previousDependentQuestion.visible = false;
				this.removeDependentQuestions(previousDependentQuestion);
			}
			if (previousDependentAnswer && !newDeps?.includes(id)) {
				delete previousDependentAnswer[id];
			}
		});

		if (this.isRenderDependentQuestion) {
			this.renderQuestions();
		}

		// Show dependent Question
		newDeps?.forEach((id) => {
			const dependentQuestion = this.questions.find((question) => question.id === id);
			if (dependentQuestion) {
				this.updateAnswers(dependentQuestion, this?.answers?.[dependentQuestion?.step]?.[id] || "");
				dependentQuestion.visible = true;
			}
		});

		if (this.isRenderDependentQuestion) {
			this.renderQuestions();
		}
		this.checkStepsOnSelection();
	}

	checkStepsOnSelection() {
		const stepContainers = SelectorEngine.find(`.lta-form-generator__step`, this.containerEl);
		for (let stepContainer = 0; stepContainer < stepContainers?.length; stepContainer++) {
			const hasQuestion = this.hasQuestionInStep(stepContainers[stepContainer]);
			this.hasQuestionSteps[stepContainer] = hasQuestion ? true : false;
		}
	}

	hasQuestionInStep(element) {
		const questionContainers = SelectorEngine.find(`.lta-form-generator__question-container`, element);
		for (let questionContainer = 0; questionContainer < questionContainers?.length; questionContainer++) {
			if (questionContainers[questionContainer].hasChildNodes()) {
				return true;
			}
		}
		return false;
	}

	renderQuestion(question) {
		if (question.ref) {
			return;
		}

		const commonConfig = {
			beforeDependentQuestionChange: this.beforeDepChangeHandler.bind(this),
			titlePattern: this.data?.titlePattern,
			goBack: () => {
				if (this.currentStep > 0) {
					this.currentStep = this.currentStep - 1;
				}
			}
		};
		
		const questionContainer = SelectorEngine.findOne(`.js-form-generator-question-${question.id}`, this.containerEl);
		switch (question.questionType) {
			case QuestionTypes.FileUpload:
				question.ref = new FileUploadComponent(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.Checkbox:
				question.ref = new CheckboxComponent(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.Info:
				question.ref = new KeyPoints(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.Radio:
				question.ref = new RadioComponent(questionContainer, {
					data: {
						answerField: this.data?.radioAnswerField || 'label',
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.Select:
				question.ref = new SelectComponent(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.DateComponent:
				question.ref = new DateComponent(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.DuetDateComponent:
				question.ref = new DuetDateComponent(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.SchoolSortCode:
				question.ref = new SchoolInputCode(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.CountySearch:
				question.ref = new SearchInputField(questionContainer, {
					data: {
						...question,
						...extraCountyData,
						...commonConfig
					}
				});
				question.ref.dataMapping = (item) => {
					return {
						firstLineText: item,
						dataKey: extraCountyData.dataKey,
						dataValue: item
					};
				};
				question.ref.filterDataMapping = (item, event) => {
					return item === event[extraCountyData.dataKey];
				};
				question.ref.searchInputMappingChange();
				break;
			case QuestionTypes.SchoolSearch:
				question.ref = new SchoolFinder(questionContainer, {
					data: {
						...question,
						...extraSchoolData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.AddressFinder:
				question.ref = new AddressFinder(questionContainer, {
					data: {
						...question,
						...extraAddressData,
						...commonConfig
					}
				});
				break;		
			case QuestionTypes.Checkout:
				question.ref = new CheckoutComponent(questionContainer, {
					data: {
						...question,
						...commonConfig,
						onSuccess: this.data?.checkoutSuccess,
						userDetails: this.data?.userDetails
					}
				});
				break;
			case QuestionTypes.UniversitySearch:
				question.ref = new SchoolFinder(questionContainer, {
					data: {
						...question,
						...extraUniversityData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.TournamentSearch:
				question.ref = new TournamentFinder(questionContainer, {
					data: {
						...question,
						...extraTournamentData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.TournamentEventDetails:
				question.ref = new TournamentEventDetails(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.TournamentEventForm:
				question.ref = new TournamentEventForm(questionContainer, {
					data: {
						...question,
						...extraTournamentData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.ParkFinder:
				question.ref = new ParkFinder(questionContainer, {
					data: {
						...question,
						...extraParkData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.AffiliatedVenueSearchList:
				question.ref = new AffiliatedVenueSearchList(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.CoachVenueSearch:
				question.ref = new ParkFinder(questionContainer, {
					data: {
						...question,
						...extraCoachVenueSearchData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.TextArea:
				question.ref = new InputField(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.ITTProviderSearch:
				question.ref = new InputField(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.CoachSearch:
				question.ref = new CoachFinder(questionContainer, {
					data: {
						...question,
						...extraCoachData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.VenueAddressSearch:
				question.ref = new VenueAddressSearch(questionContainer, {
					data: {
						...question,
						...commonConfig,
						saveAddress: this.data?.saveAddress ?? true 
						// Do not pass the value from setps pass the value as false from JS if you want don not want to update the address
						//this.formGenerator = new FormGenerator(this.form, {
						// ...
						// 	saveAddress: false
						// });
					}
				});
				break;
			case QuestionTypes.MentorFinder:
				question.ref = new MentorFinder(questionContainer, {
					data: {
						...question,
						...extraMentorData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.FormTable:
				question.ref = new FormTable(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.AuthorityFinder:
				question.ref = new AuthorityFinder(questionContainer, {
					data: {
						...question,
						...extraAuthorityData,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.PlayerList:
				question.ref = new PlayerList(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.ContactNumber:
				question.ref = new ContactNumber(questionContainer, {
					data: {
						...question,
						...commonConfig
					}
				});
				break;
			case QuestionTypes.SessionPlayerList:
				question.ref = new SessionPlayersList(questionContainer, {
					data: {
						...question,
						...commonConfig,
						hasPerformActionOnload: true
					}
				});
				break;
			default:
				// eslint-disable-next-line no-console
				console.error(`Question type ${question.questionType} is not recognised`);
				break;
		}
		this.initQuestionEventHandlers(question);
	}

	initQuestionEventHandlers(question) {
		question.ref?.onChange((answer, previousValue) => {
			this.updateAnswers(question, answer, previousValue);
			this.nextButtonToggle();
		});
	}

	removeQuestion(question) {
		question?.ref?.remove();
		delete question?.ref;
	}

	updateAnswers(question, answer) {
		this.answers = {
			...this.answers,
			[question.step]: {
				...this.answers?.[question.step],
				[question.id]: answer
			}
		};
	}

	getStepTitle() {
		const stepQuestion = this.questions.find((question) => question.step === this.currentStep);
		return stepQuestion?.stepperTitle || this.data?.stepTitle || 'Your school';
	}

	updateStep() {
		if (this.stepper) {
			this.stepper.updateState({ stepTitle: this.getStepTitle(), currentStepCount: this.currentStep });
			const existingStepperComponentWrapper = SelectorEngine.findOne(`.${this.classPrefix}__stepper`, this._element);
			existingStepperComponentWrapper.innerHTML = this.stepper.markup();
		}
		// Hide all steps.
		const previousStepContainers = SelectorEngine.find(
			`.${this.classPrefix}__step:not(.${ClassNames.Hidden})`,
			this.containerEl
		);
		if (previousStepContainers?.length > 0) {
			for (const previousStepContainer of previousStepContainers) {
				this.hide(previousStepContainer);
			}
		}

		// Show the current step.
		const currentStepContainer = SelectorEngine.findOne(
			`.js-form-generator-step-${this.currentStep}`,
			this.containerEl
		);
		!!currentStepContainer && this.show(currentStepContainer);

		this.updateStepButtonLabel();
		this.nextButtonToggle();
	}

	nextButtonToggle() {
		const isButtonVisible = this.nextValidator(this.currentStep);
		if (isButtonVisible) {
			this.nextButtonEl?.classList.remove(HIDE_CLASS);
		} else {
			this.nextButtonEl?.classList.add(HIDE_CLASS);
		}
	}

	updateStepButtonLabel() {
		let buttonLabel = 'Next';
		if (this.currentStep === this.totalSteps) {
			buttonLabel = this.data?.submitButton?.title || 'Next';
		}
		if (this.nextButtonEl) this.nextButtonEl.innerHTML = buttonLabel;
	}

	stepValidator(step) {
		// Check if questions on current step are answered.
		const stepsValidator = [];
		const questionList = this.questions.filter((question) => question.step === step);
		for (const question of questionList) {
			const currentAnswerIsValid = question?.ref?.validate(true);
			const currentAnswer = this.answers?.[question.step]?.[question.id];

			// TODO: This 'N/A' hack shouldn't be here
			if (!question.visible || question.isOptional || currentAnswer?.value === 'N/A') {
				continue;
			}

			// TODO: We should avoid checking .value here, and rely on the validate() method from the question type
			if (currentAnswerIsValid === false || currentAnswer?.value === undefined || currentAnswer?.value === null) {
				stepsValidator.push(false);
			}
		}
		return stepsValidator?.includes(false) ? false : true;
	}

	nextValidator(step) {
		return (
			this.questions.filter((question) => {
				if (question.step === step && question.visible && !question.isOptional) {
					return question?.ref?.shouldShowNext ? !question.ref.shouldShowNext() : false;
				}
				return false;
			})?.length === 0
		);
	}

	hide(element) {
		element.classList?.add(ClassNames.Hidden);
	}

	show(element) {
		element.classList?.remove(ClassNames.Hidden);
	}

	unload() {
		this.containerEl.innerHTML = '';
	}
}

/* eslint-enable unicorn/no-array-for-each */
/* eslint-enable complexity */
